export const fetchData = async (inputs) => {
  let API_URL = window.HOST_URL;

  try {
    const response = await fetch(`${API_URL}/calculator`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(inputs),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const data = await response.json();
    console.log("Data returned by backend is: ", data)
    return data;
  } catch (error) {
    if (error.name === "AbortError") {
      console.log("Fetch aborted");
    } else {
      console.error("Failed to fetch data:", error);
      throw error;
    }
  }
};
